/**
 * UserPill — Avatar circle + name in a single rounded pill.
 *
 * Restyled to the 5mi.uz warm pastel design: pastel initials avatar +
 * surface pill. On mobile (< 640px) collapses to just the avatar circle.
 */
import { Avatar } from '@/components/kit'

export default function UserPill({ user, as: As = 'a', className = '', style, ...props }) {
  const displayName = user?.full_name || user?.username || ''
  return (
    <As
      className={
        'inline-flex items-center gap-2 pl-1 pr-3 py-1 rounded-full text-sm font-medium ' +
        'transition-all cursor-pointer select-none ' + className
      }
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        color: 'var(--ink)',
        textDecoration: 'none',
        ...style,
      }}
      {...props}
    >
      <Avatar name={displayName || '?'} size={24} />
      <span className="hidden sm:inline">{displayName}</span>
    </As>
  )
}
